import Async from "components/DesignSystem/AsyncComponents/Async";
import { EmptyScreen } from "pages/Books/EmptyScreen";
import {
  Redirect,
  useLocation,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { useGetGroupDataQuery } from "store/apis/teamSetting";

export const DocumentsRootRedirect = () => {
  const { groupId } = useParams<{ groupId: string }>();
  const { url } = useRouteMatch();
  const { search } = useLocation();
  const { data, isFetching, isSuccess } = useGetGroupDataQuery(
    { groupId },
    { skip: !groupId }
  );

  const documentsGroupId = data?.documents_group_id;

  return (
    <Async.Root
      isLoading={isFetching}
      isEmpty={!documentsGroupId}
      isSuccess={isSuccess}
    >
      <Async.Empty>
        <EmptyScreen text="This company doesn't have a documents folder yet" />
      </Async.Empty>
      <Async.Success>
        <Redirect to={{ pathname: `${url}/${documentsGroupId}`, search }} />
      </Async.Success>
    </Async.Root>
  );
};
